// extracted by mini-css-extract-plugin
export var marginNegative = "_7l-5 _7l-3 _7l-1";
export var marginPositive = "_7l-4 _7l-3 _7l-1";
export var modalContent = "_7l-6";
export var samplesTable = "_7l-8";
export var samplesTableContainer = "_7l-7";
export var statBox = "_7l-a";
export var tableCell = "_7l-1";
export var tableCellCenter = "_7l-2 _7l-1";
export var tableCellRight = "_7l-3 _7l-1";
export var tableHeader = "_7l-0";
export var trackingNumber = "_7l-9";